import { verdicts } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

const toneStyles: Record<string, { badge: string; icon: string }> = {
  flip: { badge: 'bg-primary-100 text-primary-800', icon: 'ri-close-circle-line' },
  pending: { badge: 'bg-accent-100 text-accent-900', icon: 'ri-time-line' },
};

export default function VerdictSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          index="05"
          eyebrow="Verdict Card"
          title="洗白还是实锤 · 一条说法一张判断卡"
          desc="把热度最高的几句说法单独拎出来，标清楚它现在处于什么状态、靠什么材料支撑。判断会变，依据不会。"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {verdicts.map((item, index) => {
            const tone = toneStyles[item.tone] ?? toneStyles.pending;
            return (
              <article
                key={item.title}
                data-reveal
                style={{ transitionDelay: `${index * 70}ms` }}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-7"
              >
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <span
                    className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 font-label text-[11px] font-medium ${tone.badge}`}
                  >
                    <i className={tone.icon} />
                    {item.verdict}
                  </span>
                </div>
                <p className="mt-4 flex-1 text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                  {item.reason}
                </p>
                <div className="mt-5 flex items-center gap-2 border-t border-background-200 pt-4">
                  <i className="ri-folder-shield-2-line text-sm text-secondary-600" />
                  <span className="font-label text-xs text-foreground-500">
                    依据材料：{item.evidence}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}